// Baked-in reply templates for use in The Bothy admin dashboard.
// Each template is written in the Heritage Estate tone the founder uses.
// {first_name} is interpolated with the enquirer's first name at click-time.
//
// Templates live in the frontend (not the DB) deliberately — the founder
// runs the shop solo, and code edits are cheaper than a CRUD UI. If the
// library grows past ~15 templates, promote this to a backend collection
// and a small settings panel in the Bothy.

export const REPLY_TEMPLATES = [
  {
    id: 'welcome',
    label: 'Warm hello',
    subjectPrefix: 'Re:',
    body: [
      "Hi {first_name},",
      "",
      "Thank you for the note \u2014 it landed on my screen this morning. Give me a wee moment to pull the right kit together and I\u2019ll come back to you before end of play today.",
      "",
      "Slàinte,",
      "The team at EcoBike Camping Supplies Co.",
    ].join('\n'),
  },
  {
    id: 'ebike-terrain',
    label: 'E-bike \u2014 terrain match',
    subjectPrefix: 'Re:',
    body: [
      "Hi {first_name},",
      "",
      "Grand to hear from you. Before I recommend a bike, a couple of practical questions so I can match the frame to your ground:",
      "",
      "  1. Where do you plan to ride most of the time \u2014 canal towpaths, forest fire-roads, real bridleway with a bit of chunk, or a mix?",
      "  2. Your rough height and inside-leg measurement (so I can size you sensibly, not just spec-sheet you).",
      "  3. Any adaptive requirements I should know about \u2014 step-through frame, low stand-over, one-handed brake, prosthetic mount?",
      "  4. What\u2019s the longest single ride you\u2019d realistically do in a day?",
      "",
      "Once I know these I\u2019ll come back with a clear steer on whether the Juliet 2 is the right fit for you \u2014 and, if it is not, I\u2019ll point you somewhere that is. No upsell, honest match.",
      "",
      "Slàinte,",
      "The team at EcoBike Camping Supplies Co.",
    ].join('\n'),
  },
  {
    id: 'delivery-window',
    label: 'Delivery window',
    subjectPrefix: 'Re:',
    body: [
      "Hi {first_name},",
      "",
      "Quick answer on delivery: because every bike is drop-shipped straight from our manufacturing partner, allow 10 to 18 working days from the moment your payment clears. If your batch is running tight to that window I\u2019ll drop you a note before it goes so nothing surprises you.",
      "",
      "Anything else you need to know before you\u2019re ready to go ahead \u2014 just say.",
      "",
      "Slàinte,",
      "The team at EcoBike Camping Supplies Co.",
    ].join('\n'),
  },
  {
    id: 'warranty',
    label: 'Warranty & aftercare',
    subjectPrefix: 'Re:',
    body: [
      "Hi {first_name},",
      "",
      "Warranty in one place: 2 years on the frame, motor and battery, covering defects in materials and workmanship. Practically that means if it fails through normal use, we handle it \u2014 not you.",
      "",
      "First 30 days a defective bike is replaced, no argument. After that it\u2019s repair-first: we cover the parts and the labour goes to a UK bike shop we\u2019ll point you at. You never deal with a warranty portal in another time zone.",
      "",
      "Any other aftercare question \u2014 fire away.",
      "",
      "Slàinte,",
      "The team at EcoBike Camping Supplies Co.",
    ].join('\n'),
  },
  {
    id: 'adaptive-consult',
    label: 'Adaptive consult offer',
    subjectPrefix: 'Re:',
    body: [
      "Hi {first_name},",
      "",
      "Thanks for reaching out. Adaptive fitting is the bit we take most seriously \u2014 we want you on the ground, not on a waiting list.",
      "",
      "The simplest next step is a 30-minute call (phone or Zoom, whichever you prefer). We\u2019ll cover: your range of movement, any grip or prosthetic considerations, the local terrain you\u2019re thinking of riding, and whether a step-through, low stand-over or one-handed-brake spec is the best match.",
      "",
      "Reply with a couple of days and times that suit you next week and I\u2019ll block one in.",
      "",
      "Slàinte,",
      "The team at EcoBike Camping Supplies Co.",
    ].join('\n'),
  },
  {
    id: 'polite-decline',
    label: 'Polite \u201cnot our fit\u201d',
    subjectPrefix: 'Re:',
    body: [
      "Hi {first_name},",
      "",
      "Thank you for thinking of us \u2014 I appreciate you taking the time. Being honest: what you\u2019re after isn\u2019t something we can properly help with just now. I\u2019d rather say that up front than pretend otherwise and waste your time.",
      "",
      "If it\u2019s useful, I\u2019m happy to point you in a direction that might be a better fit \u2014 just reply and I\u2019ll share a couple of names.",
      "",
      "Wishing you well with it.",
      "",
      "Slàinte,",
      "The team at EcoBike Camping Supplies Co.",
    ].join('\n'),
  },
];
